import { callFunction } from "./functions-client";

// General Marketplace (LOS Phase 7).
export const LISTING_CATEGORIES = ["truck", "trailer", "equipment", "parts", "service", "other"] as const;
export const LISTING_CONDITIONS = ["new", "used", "for_parts"] as const;

export interface Listing {
  id: string;
  title: string;
  category: string;
  price_cents: number | null;
  condition?: string | null;
  location?: string | null;
  description?: string | null;
  status?: string;
  created_at: string;
  seller_name?: string | null;
  seller_profile_id?: string | null;
}

export const createListing = (input: {
  title: string; category: string; price?: string; condition?: string; location?: string; description?: string; seller_profile_id?: string;
}) => callFunction<{ listing: Listing }>("marketplace/create", { body: input });

export const listListings = (category?: string, q?: string) => {
  const p = new URLSearchParams();
  if (category) p.set("category", category);
  if (q) p.set("q", q);
  const qs = p.toString();
  return callFunction<{ listings: Listing[] }>(`marketplace/list${qs ? `?${qs}` : ""}`, { method: "GET" });
};

export const getListing = (id: string) =>
  callFunction<{ listing: Listing }>(`marketplace/get?id=${encodeURIComponent(id)}`, { method: "GET" });

export const myListings = () =>
  callFunction<{ listings: Listing[] }>("marketplace/mine", { method: "GET" });

export const setListingStatus = (id: string, status: "sold" | "removed") =>
  callFunction<{ ok: boolean; status: string }>("marketplace/set-status", { body: { id, status } });

export const priceUsd = (cents: number | null) =>
  cents == null ? "Contact for price" : `$${(cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
